/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest,
  PostApiV1CourseregistrationEnrollmentManagementStatusMutationResponse,
  PostApiV1CourseregistrationEnrollmentManagementStatus400,
  PostApiV1CourseregistrationEnrollmentManagementStatus401,
  PostApiV1CourseregistrationEnrollmentManagementStatus500,
} from "../../types/courseRegistrationEnrollmentController/PostApiV1CourseregistrationEnrollmentManagementStatus.ts";

function getPostApiV1CourseregistrationEnrollmentManagementStatusUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/courseregistration/enrollment/management-status` as const,
  };
  return res;
}

/**
 * @description Altera o status de matrícula com base nas opções de gestão disponíveis. Para status de cancelamento (Cancelado, Cancelado em Inscrição, Rejeitado), os campos StatusReasonId, SubStatusReasonId e Observation são obrigatórios. Cancela parcelas em aberto e vínculo de bolsa quando aplicável. **(Requer Authorization para autenticação)**
 * @summary Altera o status de gestão de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/management-status}
 */
export async function postApiV1CourseregistrationEnrollmentManagementStatus(
  data?: PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1CourseregistrationEnrollmentManagementStatusMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentManagementStatus400
      | PostApiV1CourseregistrationEnrollmentManagementStatus401
      | PostApiV1CourseregistrationEnrollmentManagementStatus500
    >,
    PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest
  >({
    method: "POST",
    url: getPostApiV1CourseregistrationEnrollmentManagementStatusUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
